import React from 'react';
import { Layout } from 'antd';
import { ReactComponent as EuropeanUnionLogo } from 'assets/icons/EE_alone.svg';
import { ReactComponent as EnvironmentLogo } from 'assets/icons/ministry-environment-icon-new.svg';
import { ReactComponent as GreeceGovernmentLogo } from 'assets/icons/government-greece-logo2.svg';
import { ReactComponent as GreenMinistryLogo } from 'assets/icons/green_ministry_gov.svg';
import { ReactComponent as Tayped } from 'assets/icons/tayped_logo.svg';

const { Content } = Layout;

const Footer = () => {
  return (
    <div className="footer-container">
    <div className="footer-background"></div>
    <div className="footer-content">
      <div className="footer-logo">
        <EuropeanUnionLogo/>
      </div>
      <div className="footer-logo">
        <GreenMinistryLogo className="clickable-element" onClick={() => window.open('https://ypen.gov.gr/', '_blank')}/>
      </div>
      <div className="footer-logo">
        <GreeceGovernmentLogo/>
      </div>
      {/* <div className="footer-logo">
        <Tayped/>
      </div> */}
    </div>
  </div>
  );
};

export default Footer;
